import { useMemo } from 'react'
import useAuth from 'hooks/useAuth'

export default function useDetectVersion() {
  const { profile } = useAuth()

  const isVersionAccessable = useMemo(() => {
    if (profile?.hasAccessToVersion === 0 || profile?.hasAccessToVersion) {
      const val = profile.hasAccessToVersion
      const versions: string[] = []
      /* eslint-disable no-bitwise */
      if ((val & 1) !== 0) versions.push('torisetsu')
      if ((val & 2) !== 0) versions.push('bcp')
      if ((val & 4) !== 0) versions.push('tour')
      if ((val & 8) !== 0) versions.push('rn')
      /* eslint-enable no-bitwise */
      return versions
    }
  }, [profile?.hasAccessToVersion])

  return { isVersionAccessable }
}
